import { Component, OnInit } from '@angular/core';
import { DeviceType } from '../devicetype/devicetype';
import { DeviceTypeService } from '../../services/devicetype.service';
import { TestGroupService } from '../../services/testgroup.service';
import { ApiResponse } from '../../admin/apiresponse';
import { TestGroup } from '../models/testgroup';
import { Observable, Subscription } from 'rxjs';

@Component({
    template: require('./admin.testgroup.list.component.html'),
    providers: [DeviceTypeService, TestGroupService]
})

export class TestGroupListComponent implements OnInit {

    public deviceTypes: DeviceType[] = [];
    public queryInProgress: boolean;
    public apiResponseDeviceTypes: ApiResponse;
    public apiResponseDelete: ApiResponse;
    public apiResponseGetList: ApiResponse;
    public testGroups: TestGroup[] = [];
    public busySub: Subscription;

    constructor(private devicetypeService: DeviceTypeService, private testGroupService: TestGroupService) {

    }

    ngOnInit() {
        this.getDeviceTypes();
    }

    getDeviceTypes() {
        this.busySub = this.devicetypeService.getDeviceTypes()
            .subscribe(
            success => this.setGetDeviceTypeResponse(success),
            error => this.handleError(<any>error)
            );
    }

    getTestGroupsOfDeviceType(name: string) {
        this.queryInProgress = true;
        this.busySub = this.testGroupService.getTestGroupsOfDeviceType(name)
            .subscribe(
            success => this.setGetResponse(success),
            error => this.handleError(<any>error)
            );
    }

    deleteDeviceType(deviceType:string, testGroupName: string) {
        this.busySub = this.testGroupService.deleteTestGroup(deviceType, testGroupName)
            .subscribe(
            success => this.setDeleteResponse(success),
            error => this.handleError(<any>error)
            );
    }

    setGetDeviceTypeResponse(resp: ApiResponse) {
        this.queryInProgress = false;
        this.apiResponseDeviceTypes = resp;
        this.deviceTypes = resp.data || [];
    }

    setGetResponse(resp: ApiResponse) { 
        this.apiResponseDelete = undefined;       
        this.apiResponseGetList = resp;
        this.testGroups = resp.data || [];
        this.queryInProgress = false;
    }

    setDeleteResponse(resp: ApiResponse) {
        this.queryInProgress = false;
        this.apiResponseDelete = resp;
    }

    private handleError(resp: ApiResponse) {
        console.log(resp);
    }
}


// WEBPACK FOOTER //
// ./app/admin/testgroup/admin.testgroup.list.component.ts